import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { AngularFireModule } from 'angularfire2';

import { AppComponent } from './app.component';
import { ShouterComponent } from './shouter/shouter.component';
import { DisplayerComponent } from './displayer/displayer.component';
import { FooterComponent } from './footer/footer.component';
import { NavigatorComponent } from './displayer/navigator/navigator.component';
import { HomeComponent } from './displayer/home/home.component';
import {RouterModule, Routes} from "@angular/router";
import { ProjectsComponent } from './displayer/projects/projects.component';
import { ProjectItemComponent } from './displayer/project-item/project-item.component';
import { SkillsComponent } from './displayer/skills/skills.component';
import {UtilityService} from "./utility.service";
import { ResumeComponent } from './displayer/resume/resume.component';
import { ResumeItemComponent } from './displayer/resume-item/resume-item.component';
import {FireService} from "./fire.service";
import {AngularFireDatabaseModule} from "angularfire2/database";
import { SkillsSectionComponent } from './displayer/skills-section/skills-section.component';

const firebaseConfig = {
  apiKey: "AIzaSyClgJDuS5EVNJ6GkiEF-AJ9umzIinIAaro",
  authDomain: "about-aravindm.firebaseapp.com",
  databaseURL: "https://about-aravindm.firebaseio.com",
  projectId: "about-aravindm",
  storageBucket: "about-aravindm.appspot.com",
  messagingSenderId: "566469183787"
};


const appRoutes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'projects', component: ProjectsComponent},
  {path: 'skills', component: SkillsComponent},
  {path: 'resume', component: ResumeComponent},
];

@NgModule({
  declarations: [
    AppComponent,
    ShouterComponent,
    DisplayerComponent,
    FooterComponent,
    NavigatorComponent,
    HomeComponent,
    ProjectsComponent,
    ProjectItemComponent,
    SkillsComponent,
    ResumeComponent,
    ResumeItemComponent,
    SkillsSectionComponent,

  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),

    // angularfire
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,

    // material
    BrowserAnimationsModule,
    MatCardModule,
    MatButtonModule,
    MatExpansionModule
  ],
  providers: [
    UtilityService,
    FireService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/app.module.ts